import {ALL_ID, SessionObject} from '@twpub/core/models/session-object';
import {FieldFilter} from '@twpub/core/models/field-filter';
import _ from 'lodash';

export class SearchCriteria {
  dictIds: number[];
  sectionOids: string[];
  domainIds: number[];
  sourceLangCodes: string[];
  targetLangCodes: string[];
  searchStr: string;
  fieldFilters: FieldFilter[];

  /* @deprecated Use fieldFilters */
  conceptFieldNames: string[];
  /* @deprecated Use fieldFilters */
  termFieldNames: string[];

  constructor(sessionObj: SessionObject) {
    this.dictIds = _.cloneDeep(sessionObj.dictIds || []);
    this.sectionOids = _.cloneDeep(this.arrayValue(sessionObj.sectionOids) as string[]);
    this.domainIds = _.cloneDeep(this.arrayValue(sessionObj.domainIds) as number[]);
    this.sourceLangCodes = _.cloneDeep(this.arrayValue(sessionObj.sourceLangs) as string[]);
    this.targetLangCodes = _.cloneDeep(this.arrayValue(sessionObj.targetLangs) as string[]);
    this.searchStr = sessionObj.searchTerm || '';
    this.fieldFilters = _.cloneDeep(this.arrayValue(sessionObj.fieldFilters) as FieldFilter[]);
    this.conceptFieldNames = [];
    this.termFieldNames = [];
  }

  equals(other?: SearchCriteria): boolean {
    if (!other) return false;
    return (
      JSON.stringify(this.dictIds) === JSON.stringify(other.dictIds) &&
      JSON.stringify(this.sectionOids) === JSON.stringify(other.sectionOids) &&
      JSON.stringify(this.domainIds) === JSON.stringify(other.domainIds) &&
      JSON.stringify(this.sourceLangCodes) === JSON.stringify(other.sourceLangCodes) &&
      JSON.stringify(this.targetLangCodes) === JSON.stringify(other.targetLangCodes) &&
      this.searchStr === other.searchStr &&
      JSON.stringify(this.fieldFilters) === JSON.stringify(other.fieldFilters) &&
      JSON.stringify(this.conceptFieldNames) === JSON.stringify(other.conceptFieldNames) &&
      JSON.stringify(this.termFieldNames) === JSON.stringify(other.termFieldNames)
    );
  }

  private arrayValue = (arr: string[] | number[] | FieldFilter[] | undefined) => arr?.length && arr[0].toString() !== ALL_ID ? arr : [];
}
